/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiCustomListScreeningFieldType {
    INDIVIDUAL_PERSON_NAME = 'INDIVIDUAL_PERSON_NAME',
    LEGAL_PERSON_NAME = 'LEGAL_PERSON_NAME'
}


export function instanceOfInternalApiCustomListScreeningFieldType(value: any): boolean {
    for (const key in InternalApiCustomListScreeningFieldType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiCustomListScreeningFieldType, key)) {
            if (InternalApiCustomListScreeningFieldType[key as keyof typeof InternalApiCustomListScreeningFieldType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiCustomListScreeningFieldTypeFromJSON(json: any): InternalApiCustomListScreeningFieldType {
    return InternalApiCustomListScreeningFieldTypeFromJSONTyped(json, false);
}

export function InternalApiCustomListScreeningFieldTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiCustomListScreeningFieldType {
    return json as InternalApiCustomListScreeningFieldType;
}

export function InternalApiCustomListScreeningFieldTypeToJSON(value?: InternalApiCustomListScreeningFieldType | null): any {
    return value as any;
}

export function InternalApiCustomListScreeningFieldTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiCustomListScreeningFieldType {
    return value as InternalApiCustomListScreeningFieldType;
}

